import { modalBodyLock, modalBodyLockClear } from './bodyLock';

export const centrumHeader = () => {
    let ScrollTop = 0;

    const centrumHeaderTarget = document.querySelector('.centrum-header-lower');
    const mobileCentrumNav = document.querySelector('.centrum-main-navigation');
    const centrumClose = document.querySelector('.js-close-centrum-overlay');

    if (centrumHeaderTarget) {
        centrumHeaderTarget.addEventListener('click', () => {
            if (window.innerWidth < 768) {
                mobileCentrumNav.classList.remove('mobile-centrum-nav');
                ScrollTop = modalBodyLock();
            }
        });
        centrumClose.addEventListener('click', (event) => {
            event.stopPropagation();
            mobileCentrumNav.classList.add('mobile-centrum-nav');
            modalBodyLockClear(ScrollTop);
        });
    }
};
